import "core-js/modules/es6.array.index-of";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.filter";
import Vue from 'vue';
import Decimal from 'decimal.js';

// 金额转换过滤器 分转元
Vue.filter('amountConver', function (v) {
  if (v === null || v === undefined || v === '') return '';
  try {
    var d = new Decimal(v);
    if (d.isNaN()) return v;
    return d.div(100).toFixed(2);
  } catch (e) {
    return v;
  }
});

// 金额转换过滤器 分转万元四舍五入
Vue.filter('amountConver2', function (val) {
  if (val == null || val === '') return '';
  if (Number(val) === 0) return 0;
  return Math.round(Number(val) / 1000000 * 100) / 100;
  // return (Number(val) / 100).toFixed(2)
});

// 时间转义 年月日
Vue.filter('dateText', function (val) {
  if (val == null || val === '') return '';
  var result = val.match(/^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/);
  if (result == null) {
    return val;
  }
  var date = new Date(val);
  var Y = date.getFullYear();
  var M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
  var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
  return "".concat(Y, " \u5E74 ").concat(M, " \u6708 ").concat(D, " \u65E5");
});

// 兼容不支持includes方法
if (!Array.prototype.includes) {
  Array.prototype.includes = function (val) {
    if (!this || this.length <= 0) return false;
    return this.indexOf(val) > -1;
  };
}
Vue.filter('formatOrderType', function (val) {
  return val === 2 ? '维保' : '报修';
});